export default __webpack_public_path__ + "static/media/sofiapro-bold-webfont.fe54e7c7.woff2";